"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_V3 = exports.API_BASE = void 0;
/**
 * Shared links
 */
exports.API_BASE = "/api";
exports.API_V3 = `${exports.API_BASE}/v3`;
//# sourceMappingURL=links.js.map